export const personalInfoRules = {
    "employee.employeeCode": { required: true, label: "Employee Number" },
    employmentStatusId: { required: true, label: "Employment Status" },
    payClassId: { required: true, label: "Pay Class" },
    firstName: { required: true, label: "First Name" },
    lastName: { required: true, label: "Last Name" }
    /*   mobileNumber: {
           required: true,
           pattern: /^(09|\+639)\d{9}$/,
           message: "Enter a valid PH mobile number"
       }*/
};
